import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProfileImageCropperDialogComponent } from '@libs/shared/ui/dialogs/profile-image-cropper-dialog/profile-image-cropper-dialog.component';

@Injectable()
export class ProfileImageCropperDialogService {
  constructor(private _matDialog: MatDialog) {}

  open(imageFile: File): MatDialogRef<ProfileImageCropperDialogComponent> {
    return this._matDialog.open(ProfileImageCropperDialogComponent, {
      autoFocus: true,
      disableClose: false,
      data: imageFile,
    });
  }
}
